import { Card, CardHeader, CardContent } from '@mui/material'
import PageContainer from '../layout/PageContainer'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import DataTable from '../dataTable/DataTable'
import axios from 'axios'
import { useEffect, useState } from 'react'
import DataInputs from '../dataTable/DataInputs'
import PropTypes from 'prop-types'

const PatientsList = ({ doctorId }) => {
  const [genders, setGenders] = useState([])

  useEffect(() => {
    axios.post('/lookups/genders', null).then((res) => {
      setGenders(res.data)
    })
  }, [])

  return (
    doctorId && (
      <>
        <PageContainer>
          <StoreKeyProvider storeKey="PatientsListKey">
            <WithFilters
              config={{
                page: 1,
                paginate: 10,
                orderType: 'asc',
                order: 'firstname',
                inputs: {
                  pesel: {
                    value: '',
                    relation: 'LIKE',
                  },
                  firstname: {
                    values: '',
                    relation: 'LIKE',
                  },
                  lastname: {
                    value: '',
                    relation: 'LIKE',
                  },
                  gender_id: {
                    value: null,
                    relation: 'WHERE',
                  },
                  medical_care_id: {
                    value: null,
                    relation: 'WHERE',
                  },
                  min_birth_date: {
                    value: null,
                    relation: 'MIN',
                  },
                  max_birth_date: {
                    value: null,
                    relation: 'MAX',
                  },
                  phone_number: {
                    value: null,
                    relation: 'LIKE',
                  },
                  email: {
                    value: null,
                    relation: 'LIKE',
                  },
                },
              }}
              endpoint={`/doctors/${doctorId}/patients`}
            >
              <Card elevation={2} square>
                <CardHeader title="Lista pacjentów"></CardHeader>
                <CardContent>
                  {genders && (
                    <DataInputs
                      inputs={[
                        {
                          id: 'pesel',
                          label: 'PESEL',
                          placeholder: '',
                          type: 'text',
                        },
                        {
                          id: 'firstname',
                          label: 'Imię',
                          placeholder: '',
                          type: 'text',
                        },
                        {
                          id: 'lastname',
                          label: 'Nazwisko',
                          placeholder: '',
                          type: 'text',
                        },
                        {
                          id: 'gender_id',
                          label: 'Płeć',
                          placeholder: '',
                          type: 'select',
                          options: genders,
                        },
                        {
                          id: 'birth_date',
                          label: 'Data ur.',
                          placeholder: '',
                          type: 'date-between',
                        },
                        {
                          id: 'phone_number',
                          label: 'Nr. Tel.',
                          placeholder: '',
                          type: 'tel',
                        },
                        {
                          id: 'email',
                          label: 'E-mail',
                          placeholder: '',
                          type: 'text',
                        },
                      ]}
                    />
                  )}
                  <DataTable
                    breakpoint={1471}
                    actions="PatientsTableActions"
                    labels={[
                      'PESEL',
                      'Imię',
                      'Nazwisko',
                      'Płeć',
                      'Data ur.',
                      'Nr. Tel.',
                      'E-mail',
                    ]}
                    keys={[
                      'pesel',
                      'firstname',
                      'lastname',
                      'gender_name',
                      'birth_date',
                      'phone_number',
                      'email',
                    ]}
                  />
                </CardContent>
              </Card>
            </WithFilters>
          </StoreKeyProvider>
        </PageContainer>
      </>
    )
  )
}

PatientsList.propTypes = {
  doctorId: PropTypes.number,
}

export default PatientsList
